import { Component, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from 'src/app/services/customer.service';
declare var $: any;
import * as moment from 'moment';
import { StorageService } from 'src/app/services/storage.service';
import { CustomerListDataService } from 'src/app/services/customer-list-data.service';
import { PreferencesService } from 'src/app/services/preferences.service';
import { Location } from '@angular/common';
import {
  FilterState,
  FilterChip,
} from '../../../shared/filter/filter.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css'],
})
export class CustomerListComponent implements OnInit {
  constructor(
    public router: Router,
    private customerDataService: CustomerListDataService,
    private customerService: CustomerService,
    private storageService: StorageService,
    private toastr: ToastrService,
    private preferencesService: PreferencesService,
    private authService: AuthService,
    private location: Location
  ) {
    this.router.getCurrentNavigation()?.extras;
  }

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  moment(arg0: any) {
    throw new Error('Method not implemented.');
  }

  token: any;
  userList: any;
  p: any = 1;
  count: any = 0;
  total: any = 10;
  status: any;
  id: any = '';
  search: any = '';
  fromdate: any = '';
  todate: any = '';
  userId: any = [];
  notexist: any;
  submitted: any;
  err: any;
  exportList: any;
  searchBy: string = 'id';
  isUserStatus: string = this.storageService.getItem('isUserStatus')
    ? this.storageService.getItem('isUserStatus')
    : 'approved';
  registerTime: any = [];
  accessVal: any = false;
  limit: any = 10;
  offset: any;
  userType: String = 'Approved';
  blob: any;
  rejectModalId: string = 'rejectUserListModal';
  approveModalId: string = 'approveUserDetailModal';
  tier2ApproveModalId: string = 'tier2ApproveUserListModal';
  unApproveModalId: string = 'unApproveUserListModal';
  rejectEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  unApproveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  approveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  tier2ApproveEmitter = new EventEmitter<'OPEN' | 'CLOSE'>();
  debounceTimer: any = null;
  selectedImage: string = '';

  // Make Math available in template
  Math = Math;

  // Filter properties
  showFilters: boolean = false;
  activeFilterSection: string = '';
  selectedFilters: FilterState = {
    religion: [],
    ageMin: null,
    ageMax: null,
    nationality: [],
    maritalStatus: [],
    gender: '',
    interest: [],
    values: [],
    alcoholConsumption: [],
    smoker: [],
    children: [],
    iUsuallyWakeUpAt: [],
    profileStepNo: { min: null, max: null },
    signupStepNo: { min: null, max: null },
    passportVerified: '',
    subscriptionStatus: [],
    noMatchesInLastDays: 0,
    numberOfLikes: null,
    hobbies: [],
    fitness: [],
    personality: [],
    lifeGoals: [],
    maxionGoals: [],
    meetVibes: [],
  };

  // Filter options
  religionOptions = [
    'Agnostic',
    'Atheist',
    'Buddhist',
    'Catholic',
    'Christian',
    'Hindu',
    'Jewish',
    'Muslim',
    'Sikh',
    'Spiritual',
    'Prefer not to say',
    'Other',
  ];

  nationalityOptions: any[] = [];

  maritalStatusOptions = ['Never Married', 'Married', 'Divorced', 'Separated'];

  genderOptions = ['Male', 'Female'];

  interestOptions: any[] = [];

  valueOptions: any[] = [];

  alcoholConsumptionOptions: any[] = [];

  smokingOptions: any[] = [];

  childrenOptions = ['Has Children', 'No Children'];

  wakeupAtOptions: any[] = [];

  hobbiesOptions: any[] = [];

  fitnessOptions: any[] = [];

  personalityOptions: any[] = [];

  lifeGoalsOptions: any[] = [];

  maxionGoalsOptions: any[] = [];

  meetVibesOptions: any[] = [];

  subscriptionStatusOptions = [
    'Expired',
    'Paid',
    'Unpaid',
    'Scouted_ADMIN',
    'Scouted_FRIEND',
    'Cancelled',
  ];

  // Filter chips for display
  activeFilterChips: Array<{
    key: string;
    label: string;
    value: string[] | string;
  }> = [];

  // Notification properties
  notificationTitle: string = '';
  notificationMessage: string = '';

  // Export properties
  availableExportFields = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Username' },
    { key: 'email', label: 'Email Address' },
    { key: 'countryCode', label: 'Country Code' },
    { key: 'phone', label: 'Phone Number' },
    { key: 'gender', label: 'Gender' },
    { key: 'activeSubscription', label: 'Subscription Package' },
    { key: 'age', label: 'Age' },
    { key: 'nationality', label: 'Nationality' },
    { key: 'religion', label: 'Religion' },
    { key: 'registrationDate', label: 'Registration Date' },
    { key: 'totalDatesPlanned', label: 'Total Dates Planned' },
    { key: 'totalDatesCompleted', label: 'Total Dates Completed' },
    { key: 'totalDatesCancelled', label: 'Total Dates Cancelled' },
    { key: 'totalLikesSent', label: 'Total Likes Sent' },
    { key: 'totalLikesReceived', label: 'Total Likes Received' },
    { key: 'totalMatches', label: 'Total Matches' },
    { key: 'daysToFirstMatch', label: 'Days to First Match' },
  ];

  selectedExportFields: string[] = [
    'id',
    'name',
    'email',
    'countryCode',
    'phone',
    'activeSubscription',
    'age',
    'nationality',
    'religion',
  ];

  ngOnInit(): void {
    const storageOffset = this.storageService.getItem('offset');
    this.p = storageOffset ? storageOffset + 1 : 1;

    // Check if returning from customer detail with filter state
    const state = history.state;
    if (state && state.filters) {
      this.selectedFilters = state.filters;
      this.search = state.search || '';
      this.fromdate = state.fromdate || '';
      this.todate = state.todate || '';
      this.p = state.currentPage || 1;
      this.isUserStatus = state.userStatus || 'approved';
      this.total = state.totalItems || 10;

      // Update filter chips
      this.updateFilterChips();

      console.log('Restored filter state:', this.selectedFilters);
    }

    this.userListing();
    this.loadFilterOptions();
  }

  loadFilterOptions(): void {
    this.token = localStorage['token'];

    this.preferencesService
      .getAllMasterDataOptions(this.token)
      .subscribe((res: any) => {
        if (res.status === 200 && res.data) {
          // Load interests from hobbies table
          if (res.data.hobbies) {
            this.interestOptions = res.data.hobbies;
          }

          // Load values from value table
          if (res.data.value) {
            this.valueOptions = res.data.value;
          }

          // Load alcohol consumption options
          if (res.data.alcohol_consumption) {
            this.alcoholConsumptionOptions = res.data.alcohol_consumption;
          }

          // Load smoking options from smoker table
          if (res.data.smoker) {
            this.smokingOptions = res.data.smoker;
          }

          // Load wake up time options from i_usually_wake_up_at table
          if (res.data.i_usually_wake_up_at) {
            this.wakeupAtOptions = res.data.i_usually_wake_up_at;
          }

          // Load hobbies options (same as interests for now, but separate filter)
          if (res.data.hobbies) {
            this.hobbiesOptions = res.data.hobbies;
          }

          // Load fitness options
          if (res.data.fitness) {
            this.fitnessOptions = res.data.fitness;
          }

          // Load personality options
          if (res.data.personality) {
            this.personalityOptions = res.data.personality;
          }

          // Load life goals options
          if (res.data.life_goals) {
            this.lifeGoalsOptions = res.data.life_goals;
          }

          // Load maxion goals options
          if (res.data.maxion_goals) {
            this.maxionGoalsOptions = res.data.maxion_goals;
          }

          // Load meet vibes options
          if (res.data.meet_vibes) {
            this.meetVibesOptions = res.data.meet_vibes;
          }

          // Load nationality options from country list
          if (res.data.nationalities) {
            this.nationalityOptions = res.data.nationalities.map(
              (item: any) => item.name
            );
          }
        }
      });
  }

  userListing(pageButton?: boolean) {
    this.offset = this.p - 1;
    if (pageButton) {
      this.storageService.setItem('offset', this.offset);
    }
    console.log(this.selectedFilters, 'selectedFilters');
    // Clean up filters to remove empty values
    const cleanedFilters = this.cleanFilters(this.selectedFilters);

    // For tier2, send UNAPPROVED as action
    const action =
      this.isUserStatus === 'tier2'
        ? 'UNAPPROVED'
        : this.isUserStatus === 'auto-rejected'
          ? 'AUTO-REJECTION'
          : this.isUserStatus;

    let obj = {
      limit: this.total,
      offset: this.offset,
      fromdate: this.fromdate,
      todate: this.todate,
      search: this.search,
      searchBy: this.searchBy,
      action: action,
      ...cleanedFilters,
    };

    // Add tierName for tier2 case
    if (this.isUserStatus === 'tier2') {
      obj.tierName = 'TIER2';
    } else if (this.isUserStatus === 'unapproved') {
      obj.tierName = 'TIER1';
    }

    console.log(obj, 'obj');

    this.token = localStorage['token'];
    this.userList = [];
    this.customerDataService
      .getCustomerList(obj, this.token)
      .subscribe((res: any) => {
        if (res && res.status === 200) {
          this.count = this.customerDataService.getCount();
          this.userList = this.customerDataService.getUserList();
        } else if (
          res.status == 400 &&
          res.message == 'Please provide valid token'
        ) {
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
          this.notexist = res.message;
          this.submitted = true;
          this.err = res.data;
        } else {
          this.toastr.success(res.message);
          alert(res.message);
        }
      });
  }

  // Clean up filters to remove empty values
  private cleanFilters(filters: FilterState): any {
    const cleaned: any = {};

    // Basic Information
    if (filters.religion) cleaned.religion = filters.religion;
    if (filters.nationality) cleaned.nationality = filters.nationality;
    if (filters.maritalStatus) cleaned.maritalStatus = filters.maritalStatus;
    if (filters.gender) cleaned.gender = filters.gender;

    // Age Range - use age_min and age_max instead of object
    if (filters.ageMin !== null) {
      cleaned.ageMin = filters.ageMin;
    }
    if (filters.ageMax !== null) {
      cleaned.ageMax = filters.ageMax;
    }

    // Personality & Lifestyle - extract IDs from objects
    if (filters.interest && Array.isArray(filters.interest)) {
      cleaned.interest = filters.interest.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.values && Array.isArray(filters.values)) {
      cleaned.values = filters.values.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (
      filters.alcoholConsumption &&
      Array.isArray(filters.alcoholConsumption)
    ) {
      cleaned.alcoholConsumption = filters.alcoholConsumption.map(
        (item: any) => (typeof item === 'object' && item.id ? item.id : item)
      );
    }
    if (filters.smoker && Array.isArray(filters.smoker)) {
      cleaned.smoker = filters.smoker.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.children) cleaned.children = filters.children;
    if (filters.iUsuallyWakeUpAt && Array.isArray(filters.iUsuallyWakeUpAt)) {
      cleaned.iUsuallyWakeUpAt = filters.iUsuallyWakeUpAt.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.hobbies && Array.isArray(filters.hobbies)) {
      cleaned.hobbies = filters.hobbies.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.fitness && Array.isArray(filters.fitness)) {
      cleaned.fitness = filters.fitness.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.personality && Array.isArray(filters.personality)) {
      cleaned.personality = filters.personality.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.lifeGoals && Array.isArray(filters.lifeGoals)) {
      cleaned.lifeGoals = filters.lifeGoals.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.maxionGoals && Array.isArray(filters.maxionGoals)) {
      cleaned.maxionGoals = filters.maxionGoals.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }
    if (filters.meetVibes && Array.isArray(filters.meetVibes)) {
      cleaned.meetVibes = filters.meetVibes.map((item: any) =>
        typeof item === 'object' && item.id ? item.id : item
      );
    }

    // Profile & Signup Steps
    if (filters.profileStepNo.min !== null) {
      cleaned.profileStepMin = filters.profileStepNo.min;
    }
    if (filters.profileStepNo.max !== null) {
      cleaned.profileStepMax = filters.profileStepNo.max;
    }

    if (filters.signupStepNo.min !== null) {
      cleaned.signupStepMin = filters.signupStepNo.min;
    }
    if (filters.signupStepNo.max !== null) {
      cleaned.signupStepMax = filters.signupStepNo.max;
    }

    // Status filters
    if (filters.passportVerified)
      cleaned.passportVerified = filters.passportVerified;
    if (filters.subscriptionStatus)
      cleaned.subscriptionStatus = filters.subscriptionStatus;

    // Activity filters
    if (filters.noMatchesInLastDays > 0)
      cleaned.noMatchesInLastNDays = filters.noMatchesInLastDays;
    if (filters.numberOfLikes !== null && filters.numberOfLikes !== undefined)
      cleaned.numberOfLikes = filters.numberOfLikes;

    return cleaned;
  }

  onTableDataChange(event: any) {
    this.p = event;
    this.userListing(true);
  }

  onKeyUpEvent(event: any) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    this.debounceTimer = setTimeout(() => {
      this.search = event.target.value;
      this.userListing();
    }, 500); // wait for 0.5seconds after user ends the writing
  }

  onEnterEvent(event: any) {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.search = event.target.value;
    this.userListing();
  }

  onExport(name: any) {
    if (confirm('Are you sure you want to export these Customers?')) {
      // Use the same filter logic as userListing
      const cleanedFilters = this.cleanFilters(this.selectedFilters);

      // For tier2, send UNAPPROVED as action
      const action =
        this.isUserStatus === 'tier2'
          ? 'UNAPPROVED'
          : this.isUserStatus === 'auto-rejected'
            ? 'AUTO-REJECTION'
            : this.isUserStatus;

      let obj = {
        limit: this.total,
        offset: this.offset,
        fromdate: this.fromdate,
        todate: this.todate,
        search: this.search,
        action: action,
        ...cleanedFilters,
        isExport: true,
        user_type: name,
      };

      // Add tierName for tier2 case
      if (this.isUserStatus === 'tier2') {
        obj.tierName = 'TIER2';
      } else if (this.isUserStatus === 'unapproved') {
        obj.tierName = 'TIER1';
      }
      this.token = localStorage['token'];
      this.customerDataService
        .getCustomerList(obj, this.token)
        .subscribe((res: any) => {
          // Assume the backend returns the file blob for export
          this.blob = window.URL.createObjectURL(
            new Blob([res], { type: 'application/xlsx' })
          );
          var downloadURL = window.URL.createObjectURL(res);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.setAttribute('download', 'Export Report.xlsx');
          link.click();
        });
    }
  }

  actionKey!: string;
  openModal(id: Number, action: string) {
    this.id = id;
    this.actionKey = action;
    $('#blockUnblockUser').show();
  }

  blockUnblockUser: any;
  blockUnblockDeleteAction() {
    let obj = {
      id: this.id,
      action: this.actionKey,
    };
    this.token = localStorage['token'];
    let x = document.getElementById('closeM');
    x!.setAttribute('data-dismiss', 'modal');
    this.customerService.blockUnblock(obj, this.token).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success(res.message);
        $('#blockUnblockUser').hide();
        this.userListing();
      }
      if (res.status == 400) {
        this.toastr.info(res.message);
        this.userListing();
      }
    });
  }

  // reject modal
  openRejectModal(id: Number) {
    this.id = id;
    this.rejectEmitter.emit('OPEN');
    console.log('reject modal');
  }

  // move back to waitlist modal
  openUnapproveModal(id: Number) {
    this.id = id;
    this.unApproveEmitter.emit('OPEN');
  }

  updateUserApproval(event: {
    action: 'UNAPPROVE' | 'REJECTED';
    reason?: string;
  }) {
    const { reason, action } = event;
    let obj: any = {
      id: this.id,
      action,
    };

    if (reason) {
      obj.reason = reason;
    }

    this.customerService
      .updateUserApproval(obj, this.token)
      .subscribe((res: any) => {
        if (res.status === 200) {
          this.toastr.success(res.message);

          // Hide modals based on the action
          if (action === 'REJECTED') {
            this.rejectEmitter.emit('CLOSE');
          } else if (action === 'UNAPPROVE') {
            this.unApproveEmitter.emit('CLOSE');
          }

          this.userListing();
        } else {
          this.toastr.error(res.message);
        }
      });
  }

  openApprovedUnapprovedUserModal(id: any) {
    this.id = id;
    this.approveEmitter.emit('OPEN');
  }

  getAccess(event: any) {
    this.accessVal = event.target.checked;
    console.log(this.accessVal, 'Access');
  }

  approveUnapprovedf() {
    let obj = {
      id: this.id,
      lifetime_access: this.accessVal,
      tier: 'TIER1',
    };
    this.token = localStorage['token'];
    this.customerService
      .approvedUnapproved(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.approveEmitter.emit('CLOSE');
        }
      });
  }

  approveTier2Unapprovedf() {
    let obj = {
      id: this.id,
      tier: 'TIER2',
    };
    this.token = localStorage['token'];
    this.customerService
      .approvedUnapproved(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          this.tier2ApproveEmitter.emit('CLOSE');
        }
      });
  }

  isButtonActive(buttonStatus: any) {
    this.storageService.setItem('isUserStatus', buttonStatus);
    this.isUserStatus = buttonStatus;
    this.total = 10;
    this.p = 1;
    this.offset = 0;
    this.storageService.setItem('offset', this.offset);

    // Handle tier2 special case - no filter changes needed

    this.userListing();
  }

  galleryImages: string[] = [];
  galleryIndex: number = 0;

  openImageModal(item: any) {
    // Priority to profileImages array, fallback to profileURL
    if (item.profileImages && Array.isArray(item.profileImages) && item.profileImages.length > 0) {
      this.galleryImages = item.profileImages;
    } else if (item.profileURL) {
      this.galleryImages = [item.profileURL];
    } else {
      this.galleryImages = ['assets/images/userimg.png'];
    }

    this.galleryIndex = 0;
    this.selectedImage = this.galleryImages[0];
    $('#imageZoomModal').modal('show');
  }

  nextImage() {
    if (this.galleryImages.length <= 1) return;
    this.galleryIndex = (this.galleryIndex + 1) % this.galleryImages.length;
    this.selectedImage = this.galleryImages[this.galleryIndex];
  }

  prevImage() {
    if (this.galleryImages.length <= 1) return;
    this.galleryIndex = (this.galleryIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    this.selectedImage = this.galleryImages[this.galleryIndex];
  }

  // Filter methods
  toggleFilters() {
    this.showFilters = !this.showFilters;
    if (!this.showFilters) {
      this.activeFilterSection = '';
    }
  }

  toggleFilterSection(section: string) {
    this.activeFilterSection =
      this.activeFilterSection === section ? '' : section;
  }

  private parseNumber(value: string): number | null {
    if (value === null || value.trim() === '') {
      return null;
    }
    const num = parseInt(value, 10);
    return isNaN(num) ? null : num;
  }

  // Range input methods
  applyAgeRangeFilter(data: { min: string; max: string }) {
    this.selectedFilters.ageMin = this.parseNumber(data.min);
    this.selectedFilters.ageMax = this.parseNumber(data.max);
    this.updateFilterChips();
  }

  applyStepRangeFilter(data: { type: string; min: string; max: string }) {
    const minVal = this.parseNumber(data.min);
    const maxVal = this.parseNumber(data.max);

    if (data.type === 'profile') {
      this.selectedFilters.profileStepNo = { min: minVal, max: maxVal };
    } else {
      this.selectedFilters.signupStepNo = { min: minVal, max: maxVal };
    }
    this.updateFilterChips();
  }

  // Single select methods
  updateSingleSelect(data: { key: string; event: Event }) {
    const field = data.key as keyof FilterState;
    const value = (data.event.target as HTMLSelectElement).value;
    (this.selectedFilters as any)[field] = value;
    this.updateFilterChips();
  }

  // Multi select methods
  updateMultiSelect(data: { key: string; value: string; event: Event }) {
    const field = data.key as keyof FilterState;
    const checked = (data.event.target as HTMLInputElement).checked;
    const currentArray = (this.selectedFilters as any)[field] as any[];

    if (checked) {
      // Find the complete option object to store both id and name
      let optionToAdd: any = data.value; // Default to the value (for simple string options)

      // For options that have id/name structure, find the complete object
      const optionArrays = {
        interest: this.interestOptions,
        values: this.valueOptions,
        alcoholConsumption: this.alcoholConsumptionOptions,
        smoker: this.smokingOptions,
        iUsuallyWakeUpAt: this.wakeupAtOptions,
        hobbies: this.hobbiesOptions,
        fitness: this.fitnessOptions,
        personality: this.personalityOptions,
        lifeGoals: this.lifeGoalsOptions,
        maxionGoals: this.maxionGoalsOptions,
        meetVibes: this.meetVibesOptions,
      };

      const optionsArray = optionArrays[field as keyof typeof optionArrays];
      if (optionsArray) {
        const foundOption = optionsArray.find(
          (item: any) => item.id == data.value
        );
        if (foundOption) {
          optionToAdd = foundOption; // Store the complete object with id and name
        }
      }

      // Check if already exists (compare by id if object, or by value if string)
      const exists = currentArray.some((item: any) => {
        if (typeof item === 'object' && item.id) {
          return item.id == data.value;
        }
        return item === data.value;
      });

      if (!exists) {
        currentArray.push(optionToAdd);
      }
    } else {
      // Remove by id if object, or by value if string
      const index = currentArray.findIndex((item: any) => {
        if (typeof item === 'object' && item.id) {
          return item.id == data.value;
        }
        return item === data.value;
      });

      if (index > -1) {
        currentArray.splice(index, 1);
      }
    }

    this.updateFilterChips();
  }

  // Number input methods
  updateNumberInput(data: { key: string; event: Event }) {
    const field = data.key as keyof FilterState;
    const value = (data.event.target as HTMLInputElement).value;
    if (field === 'numberOfLikes') {
      (this.selectedFilters as any)[field] =
        value === '' ? null : this.parseNumber(value);
    } else {
      (this.selectedFilters as any)[field] = this.parseNumber(value) || 0;
    }
    this.updateFilterChips();
  }

  // Apply filters
  applyFilters() {
    this.p = 1; // Reset to first page
    this.userListing();
    this.showFilters = false;
    this.activeFilterSection = '';
  }

  // Clear all filters
  clearAllFilters() {
    this.selectedFilters = {
      religion: [],
      ageMin: null,
      ageMax: null,
      nationality: [],
      maritalStatus: [],
      gender: '',
      interest: [],
      values: [],
      alcoholConsumption: [],
      smoker: [],
      children: [],
      iUsuallyWakeUpAt: [],
      profileStepNo: { min: null, max: null },
      signupStepNo: { min: null, max: null },
      passportVerified: '',
      subscriptionStatus: [],
      noMatchesInLastDays: 0,
      numberOfLikes: null,
      hobbies: [],
      fitness: [],
      personality: [],
      lifeGoals: [],
      maxionGoals: [],
      meetVibes: [],
    };
    this.activeFilterChips = [];
    this.p = 1;
    this.userListing();
    this.updateHistoryStateWithFilters();
  }

  // Clear individual filter chip
  clearFilterChip(chip: {
    key: string;
    label: string;
    value: string[] | string;
  }) {
    switch (chip.key) {
      case 'religion':
        this.selectedFilters.religion = [];
        break;
      case 'ageRange':
        this.selectedFilters.ageMin = null;
        this.selectedFilters.ageMax = null;
        break;
      case 'nationality':
        this.selectedFilters.nationality = [];
        break;
      case 'maritalStatus':
        this.selectedFilters.maritalStatus = [];
        break;
      case 'gender':
        this.selectedFilters.gender = '';
        break;
      case 'interest':
        this.selectedFilters.interest = [];
        break;
      case 'values':
        this.selectedFilters.values = [];
        break;
      case 'alcoholConsumption':
        this.selectedFilters.alcoholConsumption = [];
        break;
      case 'smoker':
        this.selectedFilters.smoker = [];
        break;
      case 'children':
        this.selectedFilters.children = [];
        break;
      case 'iUsuallyWakeUpAt':
        this.selectedFilters.iUsuallyWakeUpAt = [];
        break;
      case 'profileStepNo':
        this.selectedFilters.profileStepNo = { min: null, max: null };
        break;
      case 'signupStepNo':
        this.selectedFilters.signupStepNo = { min: null, max: null };
        break;
      case 'passportVerified':
        this.selectedFilters.passportVerified = '';
        break;
      case 'subscriptionStatus':
        this.selectedFilters.subscriptionStatus = [];
        break;
      case 'noMatchesInLastDays':
        this.selectedFilters.noMatchesInLastDays = 0;
        break;
      case 'numberOfLikes':
        this.selectedFilters.numberOfLikes = null;
        break;
      case 'hobbies':
        this.selectedFilters.hobbies = [];
        break;
      case 'fitness':
        this.selectedFilters.fitness = [];
        break;
      case 'personality':
        this.selectedFilters.personality = [];
        break;
      case 'lifeGoals':
        this.selectedFilters.lifeGoals = [];
        break;
      case 'maxionGoals':
        this.selectedFilters.maxionGoals = [];
        break;
      case 'meetVibes':
        this.selectedFilters.meetVibes = [];
        break;
    }
    this.updateFilterChips();
    this.p = 1;
    this.userListing();
    this.updateHistoryStateWithFilters();
  }

  // Update filter chips for display
  updateFilterChips() {
    this.activeFilterChips = [];

    // Religion
    if (
      this.selectedFilters.religion &&
      this.selectedFilters.religion.length > 0
    ) {
      this.activeFilterChips.push({
        key: 'religion',
        label: 'Religion',
        value: this.selectedFilters.religion,
      });
    }

    // Age Range
    if (
      this.selectedFilters.ageMin !== null ||
      this.selectedFilters.ageMax !== null
    ) {
      this.activeFilterChips.push({
        key: 'ageRange',
        label: 'Age Range',
        value: `${this.selectedFilters.ageMin ?? 'Any'} - ${this.selectedFilters.ageMax ?? 'Any'
          }`,
      });
    }

    // Nationality
    if (
      this.selectedFilters.nationality &&
      this.selectedFilters.nationality.length > 0
    ) {
      this.activeFilterChips.push({
        key: 'nationality',
        label: 'Nationality',
        value: this.selectedFilters.nationality,
      });
    }

    // Marital Status
    if (
      this.selectedFilters.maritalStatus &&
      this.selectedFilters.maritalStatus.length > 0
    ) {
      this.activeFilterChips.push({
        key: 'maritalStatus',
        label: 'Marital Status',
        value: this.selectedFilters.maritalStatus,
      });
    }

    // Gender
    if (this.selectedFilters.gender) {
      this.activeFilterChips.push({
        key: 'gender',
        label: 'Gender',
        value: this.selectedFilters.gender,
      });
    }

    // Interests
    if (
      this.selectedFilters.interest &&
      this.selectedFilters.interest.length > 0
    ) {
      const selectedNames = this.selectedFilters.interest.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'interest',
        label: 'Interests',
        value: selectedNames,
      });
    }

    // Values
    if (this.selectedFilters.values && this.selectedFilters.values.length > 0) {
      const selectedNames = this.selectedFilters.values.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'values',
        label: 'Values',
        value: selectedNames,
      });
    }

    // Alcohol Consumption
    if (
      this.selectedFilters.alcoholConsumption &&
      this.selectedFilters.alcoholConsumption.length > 0
    ) {
      const selectedNames = this.selectedFilters.alcoholConsumption.map(
        (item: any) => {
          return typeof item === 'object' && item.name ? item.name : item;
        }
      );
      this.activeFilterChips.push({
        key: 'alcoholConsumption',
        label: 'Alcohol',
        value: selectedNames,
      });
    }

    // Smoking
    if (this.selectedFilters.smoker && this.selectedFilters.smoker.length > 0) {
      const selectedNames = this.selectedFilters.smoker.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'smoker',
        label: 'Smoking',
        value: selectedNames,
      });
    }

    // Children
    if (
      this.selectedFilters.children &&
      this.selectedFilters.children.length > 0
    ) {
      this.activeFilterChips.push({
        key: 'children',
        label: 'Children',
        value: this.selectedFilters.children,
      });
    }

    // Wakeup At
    if (
      this.selectedFilters.iUsuallyWakeUpAt &&
      this.selectedFilters.iUsuallyWakeUpAt.length > 0
    ) {
      const selectedNames = this.selectedFilters.iUsuallyWakeUpAt.map(
        (item: any) => {
          return typeof item === 'object' && item.name ? item.name : item;
        }
      );
      this.activeFilterChips.push({
        key: 'iUsuallyWakeUpAt',
        label: 'Wakeup Time',
        value: selectedNames,
      });
    }

    // Profile Step No
    if (
      this.selectedFilters.profileStepNo.min !== null ||
      this.selectedFilters.profileStepNo.max !== null
    ) {
      this.activeFilterChips.push({
        key: 'profileStepNo',
        label: 'Profile Step',
        value: `${this.selectedFilters.profileStepNo.min ?? 'Any'} - ${this.selectedFilters.profileStepNo.max ?? 'Any'
          }`,
      });
    }

    // Signup Step No
    if (
      this.selectedFilters.signupStepNo.min !== null ||
      this.selectedFilters.signupStepNo.max !== null
    ) {
      this.activeFilterChips.push({
        key: 'signupStepNo',
        label: 'Signup Step',
        value: `${this.selectedFilters.signupStepNo.min ?? 'Any'} - ${this.selectedFilters.signupStepNo.max ?? 'Any'
          }`,
      });
    }

    // Passport Verified
    if (this.selectedFilters.passportVerified) {
      this.activeFilterChips.push({
        key: 'passportVerified',
        label: 'Passport',
        value: this.selectedFilters.passportVerified,
      });
    }

    // Subscription Status
    if (
      this.selectedFilters.subscriptionStatus &&
      this.selectedFilters.subscriptionStatus.length > 0
    ) {
      this.activeFilterChips.push({
        key: 'subscriptionStatus',
        label: 'Subscription',
        value: this.selectedFilters.subscriptionStatus,
      });
    }

    // No Matches in Last Days
    if (this.selectedFilters.noMatchesInLastDays > 0) {
      this.activeFilterChips.push({
        key: 'noMatchesInLastDays',
        label: 'No Matches',
        value: `${this.selectedFilters.noMatchesInLastDays} days`,
      });
    }

    // Number of Likes
    if (
      this.selectedFilters.numberOfLikes !== null &&
      this.selectedFilters.numberOfLikes !== undefined
    ) {
      this.activeFilterChips.push({
        key: 'numberOfLikes',
        label: 'Number of Likes',
        value: `${this.selectedFilters.numberOfLikes} likes`,
      });
    }

    // Hobbies
    if (
      this.selectedFilters.hobbies &&
      this.selectedFilters.hobbies.length > 0
    ) {
      const selectedNames = this.selectedFilters.hobbies.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'hobbies',
        label: 'Hobbies',
        value: selectedNames,
      });
    }

    // Fitness
    if (
      this.selectedFilters.fitness &&
      this.selectedFilters.fitness.length > 0
    ) {
      const selectedNames = this.selectedFilters.fitness.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'fitness',
        label: 'Fitness',
        value: selectedNames,
      });
    }

    // Personality
    if (
      this.selectedFilters.personality &&
      this.selectedFilters.personality.length > 0
    ) {
      const selectedNames = this.selectedFilters.personality.map(
        (item: any) => {
          return typeof item === 'object' && item.name ? item.name : item;
        }
      );
      this.activeFilterChips.push({
        key: 'personality',
        label: 'Personality',
        value: selectedNames,
      });
    }

    // Life Goals
    if (
      this.selectedFilters.lifeGoals &&
      this.selectedFilters.lifeGoals.length > 0
    ) {
      const selectedNames = this.selectedFilters.lifeGoals.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'lifeGoals',
        label: 'Life Goals',
        value: selectedNames,
      });
    }

    // Maxion Goals
    if (
      this.selectedFilters.maxionGoals &&
      this.selectedFilters.maxionGoals.length > 0
    ) {
      const selectedNames = this.selectedFilters.maxionGoals.map(
        (item: any) => {
          return typeof item === 'object' && item.name ? item.name : item;
        }
      );
      this.activeFilterChips.push({
        key: 'maxionGoals',
        label: 'Maxion Goals',
        value: selectedNames,
      });
    }

    // Meet Vibes
    if (
      this.selectedFilters.meetVibes &&
      this.selectedFilters.meetVibes.length > 0
    ) {
      const selectedNames = this.selectedFilters.meetVibes.map((item: any) => {
        return typeof item === 'object' && item.name ? item.name : item;
      });
      this.activeFilterChips.push({
        key: 'meetVibes',
        label: 'Meet Vibes',
        value: selectedNames,
      });
    }
  }

  // Notification methods
  openNotificationModal() {
    this.notificationTitle = '';
    this.notificationMessage = '';
    $('#notificationModal').modal('show');
  }

  sendNotification() {
    if (!this.notificationTitle || !this.notificationMessage) {
      this.toastr.error('Please fill in both title and message');
      return;
    }

    // Call userListing with notification parameters
    this.userListingWithNotification();

    // Close the modal
    $('#notificationModal').modal('hide');

    // Clear the form
    this.notificationTitle = '';
    this.notificationMessage = '';
  }

  userListingWithNotification() {
    this.offset = this.p - 1;

    // Clean up filters to remove empty values
    const cleanedFilters = this.cleanFilters(this.selectedFilters);

    // For tier2, send UNAPPROVED as action
    const action =
      this.isUserStatus === 'tier2'
        ? 'UNAPPROVED'
        : this.isUserStatus === 'auto-rejected'
          ? 'AUTO-REJECTION'
          : this.isUserStatus;

    let obj = {
      limit: this.total,
      offset: this.offset,
      fromdate: this.fromdate,
      todate: this.todate,
      search: this.search,
      action: action,
      ...cleanedFilters,
      // Add notification parameters
      isNotification: true,
      notificationTitle: this.notificationTitle,
      notificationMessage: this.notificationMessage,
    };

    // Add tierName for tier2 case
    if (this.isUserStatus === 'tier2') {
      obj.tierName = 'TIER2';
    }

    this.token = localStorage['token'];
    this.userList = [];
    this.customerDataService.getCustomerList(obj, this.token).subscribe(
      (res: any) => {
        if (res && res.status === 200) {
          this.count = this.customerDataService.getCount();
          this.userList = this.customerDataService.getUserList();
          this.toastr.success('Notification sent successfully!');
        } else if (
          res.status == 400 &&
          res.message == 'Please provide valid token'
        ) {
          this.toastr.error(res.message);
          this.router.navigate(['/login']);
          this.notexist = res.message;
          this.submitted = true;
          this.err = res.data;
        } else {
          this.toastr.error(res.message || 'Failed to send notification');
        }
      },
      (error) => {
        this.toastr.error(
          error?.error?.message || 'Failed to send notification'
        );
      }
    );
  }

  // Add this method to handle navigation with filter data
  navigateToCustomerDetail(customerId: number) {
    // Create a state object with all filter data
    const navigationState = {
      filters: this.selectedFilters,
      search: this.search,
      fromdate: this.fromdate,
      todate: this.todate,
      currentPage: this.p,
      userStatus: this.isUserStatus,
      totalItems: this.total,
    };

    console.log(navigationState);

    // Navigate with state
    this.router.navigate(['/customer-detail', customerId, this.isUserStatus], {
      state: navigationState,
    });
  }

  updateHistoryStateWithFilters() {
    const state = {
      filters: this.selectedFilters,
      search: this.search,
      fromdate: this.fromdate,
      todate: this.todate,
      currentPage: this.p,
      userStatus: this.isUserStatus,
      totalItems: this.total,
    };
    this.location.replaceState(this.router.url, '', state);
  }

  // Export modal methods
  openExportModal() {
    $('#exportModal').modal('show');
  }

  getFirstHalfFields() {
    const half = Math.ceil(this.availableExportFields.length / 2);
    return this.availableExportFields.slice(0, half);
  }

  getSecondHalfFields() {
    const half = Math.ceil(this.availableExportFields.length / 2);
    return this.availableExportFields.slice(half);
  }

  toggleExportField(fieldKey: string) {
    const index = this.selectedExportFields.indexOf(fieldKey);
    if (index > -1) {
      this.selectedExportFields.splice(index, 1);
    } else {
      this.selectedExportFields.push(fieldKey);
    }
  }

  selectAllExportFields() {
    this.selectedExportFields = this.availableExportFields.map(
      (field) => field.key
    );
  }

  clearAllExportFields() {
    this.selectedExportFields = [];
  }

  exportWithSelectedFields() {
    if (this.selectedExportFields.length === 0) {
      this.toastr.error('Please select at least one field to export');
      return;
    }

    if (
      confirm(
        'Are you sure you want to export these Customers with the selected fields?'
      )
    ) {
      // Use the same filter logic as userListing
      const cleanedFilters = this.cleanFilters(this.selectedFilters);

      // For tier2, send UNAPPROVED as action
      const action =
        this.isUserStatus === 'tier2'
          ? 'UNAPPROVED'
          : this.isUserStatus === 'auto-rejected'
            ? 'AUTO-REJECTION'
            : this.isUserStatus;

      let obj = {
        limit: this.total,
        offset: this.offset,
        fromdate: this.fromdate,
        todate: this.todate,
        search: this.search,
        action: action,
        ...cleanedFilters,
        isExport: true,
        user_type: this.isUserStatus,
        exportFields: this.selectedExportFields, // Pass selected fields to backend
      };

      // Add tierName for tier2 case
      if (this.isUserStatus === 'tier2') {
        obj.tierName = 'TIER2';
      }

      this.token = localStorage['token'];
      this.customerDataService
        .getCustomerList(obj, this.token)
        .subscribe((res: any) => {
          // Assume the backend returns the file blob for export
          this.blob = window.URL.createObjectURL(
            new Blob([res], { type: 'application/xlsx' })
          );
          var downloadURL = window.URL.createObjectURL(res);
          var link = document.createElement('a');
          link.href = downloadURL;
          link.setAttribute('download', 'Export Report.xlsx');
          link.click();

          // Close the modal
          $('#exportModal').modal('hide');
        });
    }
  }

  formatSocialUrl(url: string | undefined): string {
    if (!url) return '';
    // Check if it already starts with http:// or https://
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  }
}
